// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"JF7pb","orderHistory-navigation":"+BnCL","orderHistory-content":"ma6xm","orderHistory-content-date":"fIZ0o"};